export const theme = {
  color: {
    red: '#e64d3d',
    blue: '#034fb3',
    lightBlue: '#5c9ceb',
    grey: '#a7abb7',
    mediumGrey: '#e7e7e7',
    lightGrey: '#f7f7f7',
    white: '#fefefe',
    black: '#4a4a4a',
    realBlack: '#000000'
  },
  trailColor: {
    green: '#6acb21',
    red: '#e64d3d',
    blue: '#034fb3',
    black: '#333333',
  },
  fontSize: {
    small: '11px',
    medium: '12px',
    large: '16px',
    xl: '24px',
    xxl: '36px',
  },
  mediaQuery: {
    tablet: '@media (min-width: 768px)',
    desktop: '@media (min-width: 1024px)',
  },
  mqMinWidth: {
    tablet: 768,
    desktop: 1024,
  }
};
